function MokStdRedirect () {
    return(
        <div>MokStdRedirect</div>
    );
}

export default MokStdRedirect;